import React from 'react';

import { Box, Group, Text, px, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { getAdjustedColorOpacity } from 'utils/colors';

import AgendaEvent from './interface';
import useEventCalendarAgendaStyles from './styles';

interface IAgendaItemProps {
  event: AgendaEvent;
  onClick: () => void;
}

const AgendaItem = ({ event, onClick }: IAgendaItemProps): JSX.Element => {
  const { classes } = useEventCalendarAgendaStyles();
  const theme = useMantineTheme();
  const isDesktop = useMediaQuery(`(min-width: ${theme.breakpoints.sm}`, true);
  const adjustedColorOpacity = getAdjustedColorOpacity(event.color, 0.5);
  return (
    <Box
      p={0}
      mb='md'
      className={`${classes.agendaItem} ${classes.grid} ${classes.shadow}`}
      onClick={onClick}
      data-cy='agendaViewItem'
    >
      <Group
        sx={{ background: `linear-gradient(to right, ${event.color} 3%, ${adjustedColorOpacity} 2%)` }}
        className={`${classes.firstColumn}`}
      >
        <Text fw='bold' fz='sm' truncate>
          {event.startTime} - {event.endTime}
        </Text>
      </Group>
      <Group bg={adjustedColorOpacity} mr='auto' pr='sm' className={classes.name}>
        <Text fw='bold' fz='sm' truncate w={isDesktop ? `${px(theme.spacing.xl) * 6}px` : 'inherit'}>
          {event.name}
        </Text>
      </Group>
      <Group
        className={`${classes.coach}`}
        sx={isDesktop ? {} : { background: `linear-gradient(to right, ${event.color} 3%, white 2%)` }}
      >
        <Text fz='sm' truncate>
          {event.coaches}
        </Text>
      </Group>
      <Group className={`${classes.location}`}>
        <Text fz='sm' truncate>
          {event.location}
        </Text>
      </Group>
      <Group className={`${classes.middleColumn}`}>
        <Text fz='sm'>{event.eventSize}</Text>
      </Group>
      <Group className={`${classes.lastColumn}`}>
        <Text fz='sm'>{event.waitlist}</Text>
      </Group>
    </Box>
  );
};

export default AgendaItem;
